import CardCommon from '@op/components/CardCommon';
import React, { useMemo } from 'react';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import BubbleCommon from '@/pages/opinion/components/BubbleCommon';
import './index.scss';
import { reviewsFormat } from '@op/utils/value';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import { formatDateFunc } from '@op/utils/time';
import SmallChart from '@op/pages/Summary/components/SmallChart';
// import { goStatsDetailAction } from '@op/pages/stats/Detail';
// import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import moment from 'moment';
import { useKeyOpinionsRisingTopic } from '@op/pages/Overview/KeyOpinions/hook';
import { useLocalLanguage } from '@op/utils/languageValue';
import { keyOpinionsRisingTopicsStudio } from './utils';

export default function RisingTopics({
  filter,
  translateTopic,
  languageType
}: any) {

  const ExtraFilter = useMemo(()=>({
    ...filter,
    top_n: 4,
    is_valid: [2,1,3],
    social_media_by_account: undefined,
    social_media_by_keyword: undefined,
  }),[filter]);

  const { data, loading } = useKeyOpinionsRisingTopic({
    filter: ExtraFilter,
    extraData: '',
  });

  const { formatMessage } = useLocalLanguage({
    languageType: languageType || 'origin',
  });

  // const history = useHistory();
  // const goTopicDetails = (name = '') => {
  //   if (name) {
  //     buriedBtnPoint('KONO_ClickTopic', name);
  //   }
  //   goStatsDetailAction({
  //     path: `/opinion/Summary/TopicTracking`,
  //     params: {
  //       ...filter,
  //       ...gameInfo,
  //       topic: name ? [name] : [],
  //     },
  //     history,
  //   });
  // };

  const formatDate = useMemo(() => {
    if (filter?.date_type === 'monthly') {
      return formatDateFunc('daily');
    }
    if (
      filter?.date_type === 'daily' &&
      moment(filter?.start_time).isSame(moment(), 'day') &&
      moment(filter?.end_time).isSame(moment(), 'day')
    ) {
      return formatDateFunc('hourly');
    }
    return formatDateFunc(filter?.date_type);
  }, [filter]);

  return (
    <CardCommon
      className="dbo-rising-topic"
      title={
        <div className="dbo-rising-topic-title">
          <span> {formatMessage({ id: 'Rising Topics' })}</span>
          <BubbleCommon tipsMap={keyOpinionsRisingTopicsStudio} placement={'top'} />
        </div>
      }
      hasEmptyDesc={false}
      contentCard
      loading={loading}
      empty={data?.length === 0}
      loadingHeight={130}
      emptyHeight={130}
      logBtnId="KONO_Topic"
    >
      <div className="dbo-rising-topic-list">
        {data?.map((val) => {
          const {
            name,
            mentions,
            old_mentions,
            rising,
            oldTime,
            newTime,
            xAxisData,
            yAxisData,
          } = val;
          const { date_type: dateType } = filter;
          return (
            <CardCommon
              className="dbo-topic-card-common"
              title={translateTopic(name)}
              hasTitleArrow
              contentCard
              key={name}
              // handleTitleOnClick={() => goTopicDetails(name)}
            >
              <div className="dbo-numbers-flex">
                <div className="dbo-numbers-flex-content">
                  <div className="dbo-numbers-flex-num">
                    {reviewsFormat(mentions)}
                  </div>
                  <div className="dbo-numbers-flex-trend">
                    <RingRatioBubble
                      formateValue={reviewsFormat}
                      formateDate={formatDate}
                      oldTime={oldTime}
                      newTime={newTime}
                      oldValue={old_mentions}
                      newValue={mentions}
                      title={formatMessage({ id: 'Mentions' })}
                    >
                      <PercentageItem percentage={rising} />
                    </RingRatioBubble>
                  </div>
                </div>
                <div className="dbo-numbers-flex-chart">
                  <SmallChart
                    text={formatMessage({ id: 'Mentions' })}
                    statistics={{ x: xAxisData, y: yAxisData }}
                    name={translateTopic(name)}
                    formatValueFunc={(value: number) =>
                      reviewsFormat(value, 2, '-')
                    }
                    dateType={dateType}
                  />
                </div>
              </div>
            </CardCommon>
          );
        })}
      </div>
    </CardCommon>
  );
}
